module.exports = __webpack_public_path__ + "img/full2-min.55690d64.png";